import React, { Component } from "react";
import Password_managementForm from "../Password_managementForm/Password_managementForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Social_BenefitsPage
Description : Componente que contienen el formulario de la pantalla Social_Benefits 
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina – Se llama al componente Social_BenefitsForm
================================================================================ */

class Password_managementPage extends Component{
    render(){
        return(
            <div>                    
                <Password_managementForm/>
            </div>
        )   
    }
}

export default Password_managementPage;